import React from "react";
import composedRightToWork from "../../../containers/RightToWorkContainer";
import RightToWork from "./RightToWork";

const RightToWorkMainComponent = (props) => {
  return <RightToWork />;
};

export default composedRightToWork(RightToWorkMainComponent);
